
export const RECEIVE_COMPLAINT = {
    REQUEST: 'COMPLAINT_SELLER.RECEIVE_COMPLAINT.REQUEST',
    SUCCESS: 'COMPLAINT_SELLER.RECEIVE_COMPLAINT.SUCCESS',
    FAILED: 'COMPLAINT_SELLER.RECEIVE_COMPLAINT.FAILED',
};

export const CLEAR_STATE = 'COMPLAINT_SELLER.RECEIVE_COMPLAINT.CLEAR_STATE';
